(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotDetailController', PurchaseItemLotDetailController);

    PurchaseItemLotDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PurchaseItemLot', 'PurchaseItem'];

    function PurchaseItemLotDetailController($scope, $rootScope, $stateParams, entity, PurchaseItemLot, PurchaseItem) {
        var vm = this;
        vm.purchaseItemLot = entity;

        var unsubscribe = $rootScope.$on('sigmasfApp:purchaseItemLotUpdate', function(event, result) {
            vm.purchaseItemLot = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
